<div class="global-loading-overlay" *ngIf="loadingService.isLoading()">
  <div class="overlay-inner">
    <app-loader></app-loader>
  </div>
</div>
